import { ChainId } from 'tombswap-sdk'
import MULTICALL_ABI from './abi.json'
import { multicall } from '../../tombswap_address.json'

const MULTICALL_NETWORKS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: multicall,
  [ChainId.FTMTESTNET]: multicall,
  [ChainId.ETHMAINNET]: multicall,
  [ChainId.BSC]: multicall
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
